import { PortableTextBlock } from "@portabletext/types";
import * as styles from "./Block.css";
import { Heading } from "~/components/elements/Heading";
import { Paragraph } from "~/components/elements/Paragraph";
import clsx from "clsx";
import { BlockQuoteString } from "~/components/elements/BlockQuoteString";

type Props = {
  value: PortableTextBlock;
} & React.HTMLAttributes<HTMLDivElement>;

export default function Block({ children, value, className }: Props) {
  // console.log(value);

  // Used to add line breaks without having to shift+enter in sanity editor
  if (Array.isArray(children) && children.length === 1 && children[0] === "") {
    return <br />;
  }

  if (value.style === "h1") {
    return (
      <Heading as="h1" size="h1">
        {children}
      </Heading>
    );
  } else if (value.style === "h2") {
    return (
      <Heading as="h2" size="h3">
        {children}
      </Heading>
    );
  } else if (value.style === "h3") {
    return (
      <Heading as="h3" size="h4">
        {children}
      </Heading>
    );
  } else if (value.style === "h4") {
    return (
      <Heading as="h4" size="h5">
        {children}
      </Heading>
    );
  } else if (value.style === "subheading") {
    return <Paragraph className={styles.subheading}>{children}</Paragraph>;
  } else if (value.style === "caption") {
    return (
      <Paragraph size="sm" className={styles.caption}>
        {children}
      </Paragraph>
    );
  } else if (value.style === "blockquote") {
    return (
      <BlockQuoteString
        data={{
          quote: value.children.map((child) => child.text.trim()).join(" "),
        }}
      />
    );
  }

  return (
    <Paragraph className={clsx(className, styles.paragraph)}>
      {children}
    </Paragraph>
  );
}
